export default function ConfirmationDialog({ title, message, isEditing }) {
  return (
    <div className="col">
      <div className="row">
        <p className="fw-semibold text-primary" style={{ fontSize: "1.3rem" }}>
          {title || "Add Item"}
        </p>
        <p style={{ fontSize: "1rem" }}>
          {message || "Are you sure you want to add this item?"}
        </p>
      </div>
    </div>
  );
}
